import { memo, useCallback } from 'react';
import { Linking } from 'react-native';
import { Button, ButtonProps } from '../..';

function EmailUsButton(props: ButtonProps) {
  const shareViaEmail = useCallback(() => {
    Linking.openURL(encodeURI('mailto:support@bonanzasocial.com'));
  }, []);

  return (
    <Button
      variant="secondary"
      locNS="common"
      locKey="emailUs"
      onPress={shareViaEmail}
      alignSelf="center"
      width="100%"
      {...props}
    />
  );
}

export default memo(EmailUsButton);
